import React, { useEffect, useState } from "react";
import { Route } from "react-router";
import Header from "../../component/frontend/Header";
import Footer from "../../component/frontend/Footer";
import banner_img from "../../images/banner-profile.jpg";
import services from "../../assets/data/services.json";
import { Link } from "react-router-dom";
import Seo from "../Seo";
import { Helmet } from "react-helmet";
import { scAxiosAdmin } from "../..";
import AboutStarterCards from "./AboutStarterCards";
import MissionStatementAbout from "./MissionStatementAbout";
import AboutDescription from "./commonsections/AboutDescription";
import ResearchAndTraining from "./ResearchAndTraining";
const About = () => {
  const [videoLInk, setVideoLInk] = useState({});
  const [staticPageData, setStaticPageData] = useState([]);

  useEffect(() => {
    const getHeaderData = (data) => {
      try {
        const req = scAxiosAdmin
          .request(`/static_services_pages/44`, {
            // .request(`/staticpages/getsinglestaticpageslugdata/career`, {
            method: "get",
            headers: {
              Accept: "application/json",
              // Authorization: "Bearer " + localStorage.getItem(API_TOKEN_NAME),
            },
          })
          .then((data) => {
            if (data.status === 200) {
              // console.log('your log output',data)
              // setStaticPageData(data.data.data);
              setStaticPageData(data.data.components);
            }
          })
          .catch((e) => {
            console.log("your log output", e);
          });
      } catch (error) {}
    };
    getHeaderData();
  }, []);

  useEffect(() => {
    const getAllBanner = (data) => {
      try {
        const req = scAxiosAdmin
          .request("/settings/30", {
            method: "get",
          })
          .then((data) => {
            if (data.status === 200) {
              setVideoLInk(data.data.value);
            }
          })
          .catch((e) => {
            console.log("your log output", e);
          });
      } catch (error) {}
    };
    getAllBanner();
  }, []);

  const servicesLive = [
    { id: "a", service: "Flat Panel Digital Cathlab" },
    { id: "b", service: "Modular Operation Theatres" },
    {
      id: "c",
      service: "Critical Care (ICU/CCU/HDU/CICU/KTICU/NICU/PICU) beds",
    },
    { id: "d", service: "Fresenius 4008S Dialysis Units" },
    { id: "e", service: "Multifiltrate CRRT for critically ill patients" },
    { id: "f", service: "PET-CT Scan" },
    { id: "g", service: "Medical Cyclotron" },
    { id: "h", service: "Linear Accelerator" },
    { id: "i", service: "Spect-CT" },
    { id: "j", service: "500 Slice CT Scanner" },
    { id: "k", service: "High Definition MRI System 1.5 T" },
    { id: "l", service: "24 hour Emergency Service" },
    { id: "m", service: "4D Portable Ultrasound" },
    { id: "n", service: "24 hour Ambulance Service" },
    { id: "o", service: "24 hour Angioplasty for Heart attack patients" },
    { id: "p", service: "Cardiac Surgeries" },
    {
      id: "q",
      service: "Total Knee and Hip Replacement and Arthroscopy Surgeries",
    },
    { id: "r", service: "Kidney Transplant" },
    { id: "s", service: "Critical Brain & Spinal Surgeries" },
    { id: "t", service: "Endoscopy Facility" },
    { id: "u", service: "Digital Mammography" },
    { id: "v", service: "Mobile X-Rays" },
    { id: "w", service: "EEG and EMG Machines" },
    { id: "x", service: "Central Sterilization supply Facilities (CSSD)" },
    { id: "y", service: "CCTV facility for the whole hospital" },
    { id: "z", service: "Blood Bank" },
  ];

  return (
    <div>
      <Seo
        title="About United Hospital | Best Hospital in Bangladesh | United Hospital"
        description="United Hospital Ltd was borne out of a vision to provide a complete and one-stop healthcare solution to the people of Bangladesh."
        pathSlug="/"
        keywords="Corporate Clients"
      />
      <Helmet>
        <meta
          name="description"
          content="United Hospital Ltd was borne out of a vision to provide a complete and one-stop healthcare solution to the people of Bangladesh."
        />

        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "http://schema.org",
            "@type": "LocalBusiness",
            name: "United Hospital Limited",
            image:
              "https://media.dhakatribune.com/uploads/2018/01/WEB_united-Hospital_Facebook-Edited_11.01.2018.jpg",
            telephone: "10666",
            email: "info@uhlbd.com",
            address: {
              "@type": "PostalAddress",
              streetAddress: "plot 15, Road 71, Gulshan",
              addressLocality: "Dhaka",
              addressRegion: "Dhaka",
              addressCountry: "Bangladesh",
              postalCode: "1212",
            },
            openingHoursSpecification: {
              "@type": "OpeningHoursSpecification",
              opens:
                "Please insert valid ISO 8601 date/time here. Examples: 2015-07-27 or 2015-07-27T15:30",
            },
            url: "http://www.uhlbd.com/",
            aggregateRating: {
              "@type": "AggregateRating",
              ratingValue: "3.9",
              bestRating: "5",
              worstRating: "1",
              ratingCount: "756",
            },
            review: {
              "@type": "Review",
              author: {
                "@type": "Person",
                name: "abdul kahar",
              },
              datePublished: "2019-02-12",
              reviewRating: {
                "@type": "Rating",
                ratingValue: "3.9",
                bestRating: "5",
                worstRating: "1",
              },
              reviewBody:
                "United Hospital is the best, friendly doctors & staff, very modern and Clean Environment. Offers you World class medical services and treatment facilities. Had Experienced back 2014 ( UK. patient)",
            },
          })}
        </script>
        <meta
          name="Subject"
          content="Accident & Emergency,Anesthesiology,Cancer Surgery (OncoSurgery),CARDIAC ANESTHESIA,Cardiac Surgery,Cardiology,Critical Care, Dentistry,Dermatology,Diabetes & Endocrinology,Dietetics & Nutrition,ENT & Head Neck Surgery,Family Medicine, Gastroenterology & Hepatology,General Surgery,Health Screening,Hemodialysis,Internal Medicine,Laboratory, Laparoscopic Surgery,Neurology,Nuclear Medicine,Oncology,Plastic Surgery,Physical Medicine & Rehabilitation,Vaccination Centre,Vascular Surgery"
        />
        <meta name="Abstract" content="one-stop healthcare in Bangladesh" />
        <meta name="Googlebot" content="all" />
        <meta http-equiv="imagetoolbar" content="no" />
        <meta name="robots" content="index, follow" />
        <meta name="copyright" content="Copyright &copy; uhlbd.com" />
        <meta name="owner" content="United Hospital" />
        <meta name="author" content="dcastalia.com" />
        <meta name="Rating" content="General" />
        <meta name="distribution" content="Global" />
        <meta
          name="classification"
          content="Patient info,For Physicians,Departments,Services,Gallery,News & Events,Publication etc."
        />
        <meta name="apple-mobile-web-app-capable" content="yes" />
        <meta
          names="apple-mobile-web-app-status-bar-style"
          content="black-translucent"
        />
        <meta name="msvalidate.01" content="16C4E0B16E39354E550F64BD707F6A97" />
      </Helmet>
      <Route component={Header} />
      <div id="giveMargin" className="" style={{ backgroundColor: "#f7f5ef" }}>
        <img src={banner_img} alt="banner-profile" className="w-100" />
        <div class="">
          <section className="termscondbody mt-5 pb-5">
            <h2 className="text-center" style={{ color: "#AF9763" }}>
              About
            </h2>
            {staticPageData.length > 0
              ? staticPageData.map((section, index) => {
                  if (section.sectionTitle === "About") {
                    return section.value.map((card, cardIndex) => {
                      return (
                        <AboutStarterCards
                          card={card}
                          key={cardIndex} // Use a unique key for each card
                          index={cardIndex}
                        />
                      );
                    });
                  } else if (section.sectionTitle === "MissionVision") {
                    return (
                      <section className="container mt-2 pb-5">
                        <div className="row row-cols-1 row-cols-md-2 row-cols-lg-3 g-4">
                          {section.value.map((card, cardIndex) => {
                            return (
                              <MissionStatementAbout
                                card={card}
                                key={cardIndex} // Use a unique key for each card
                                index={cardIndex}
                              />
                            );
                          })}
                        </div>
                      </section>
                    );
                  } else if (section.sectionTitle === "ResearchAndTraining") {
                    return <ResearchAndTraining cards={section.value} />;
                  }
                  return null; // Return null for sections that are not "cardGallery"
                })
              : null}

            <div className="container">
              <div className="box-of-about border-section mb-4">
                <div className="row g-2">
                  <div className="col-lg-8 col-md-12">
                    {staticPageData.length > 0
                      ? staticPageData.map((section, index) => {
                          if (section.sectionTitle === "AboutDescription") {
                            return (
                              <AboutDescription
                                description={section.value}
                              ></AboutDescription>
                            );
                          }
                        })
                      : null}
                    {/* <div className="">
                      <div
                        className="p-3"
                        style={{
                          backgroundColor: "#ffffff",
                          borderTopRightRadius: "10px",
                          borderTopLeftRadius: "10px",
                        }}
                      >
                        UNITED HOSPITAL LIMITED
                      </div>
                    </div>
                    <div
                      className="p-3 mb-2"
                      style={{
                        backgroundColor: "#ffffff",
                        borderBottomLeftRadius: "10px",
                        borderBottomRightRadius: "10px",
                      }}
                    >
                      <p className="text-justify">
                        Opening its doors in August 2006 and situated beside the
                        picturesque Gulshan Lake, this hospital is one of the
                        largest private sector healthcare facilities in
                        Bangladesh. United Hospital has the capacity to house
                        over 500 patients and has 12 state-of-the-art operation
                        theatres to cater to the needs of varied patient base.{" "}
                        <br />
                        <br />
                        With more than 30 clinical sub specialties, our centres
                        of Excellence like Cardiac, Cancer, Renal, Surgical,
                        Neuroscience, Mother & Child Health and Critical Care
                        Centres are staffed by the most esteemed doctors in
                        their respective fields. <br />
                        <br />
                        Since inception till date (July 2021) we have conducted
                        420,000 Cardiac Investigations, 55,000 Cardiac
                        Procedures, 14,000 Heart Surgeries with 98% success
                        rate, 39 Kidney Transplant, 295,000 Haemodialysis,
                        185,000 Radiation Therapy Sessions & 196,000 Health
                        Checkups completed.
                        <br />
                        <br />
                        United Hospital has pioneered in many endeavors and has
                        achieved many breakthrough milestones. Transcatheter
                        Aortic Valve Implant (TAVI) procedure for Aortic
                        Stenosis patients, first of its kind in Bangladesh was
                        conducted in United Hospital Cardiac Centre, which also
                        prides itself with the lone & pioneer iGS 520 Hybrid
                        Cardio-Neuro Cathlab of the country. The hospital
                        Pathology Laboratory received ISO 15189:2012
                        Accreditation, as the first hospital of the country. The
                        comprehensive Cancer Care Centre of the hospital has the
                        country’s only Medical Cyclotron to produce radioactive
                        tracer isotope for all centres of the country; it also
                        has the first & only TrueBeam Linear Accelerator
                        providing accurate radiation to ensure less timed
                        precise therapy with minimal side effect. United
                        Hospital Renal Centre added Hemo Diafiltration & Bio
                        impedance technology, first time in the country, for
                        patients suffering from kidney diseases. The 3.0T Signa
                        Pioneer Wide Bore MRI in its Radiology & Imaging Centre
                        is also first of its kind in the country.
                        <br />
                        <br />
                        At United Hospital, providing our patients with a
                        trusted and compassionate environment for healthcare is
                        central to our mission. We draw strength from our
                        purpose, which is above all to help and to heal. Our
                        physicians, nurses and other caregivers & supporting
                        staff are passionate about providing the right care at
                        the right time, bringing hope and healing to our
                        patients and their families. Patients trust us with
                        their most valuable possession – their lives - and all
                        of our caregivers recognize the immense responsibility
                        that comes with that trust.
                      </p>
                    </div> */}
                    <div
                      className="p-3"
                      style={{
                        backgroundColor: "#ffffff",
                        borderRadius: "10px",
                      }}
                    >
                      <p className="text-justify mb-2">
                        We are committed to (i) Quality, (ii) Effectiveness,
                        (iii) Integration, (iv) Caring for the Community, (v)
                        Caring for our staff and (vi) Research & Training. Our
                        number one priority is to provide our patients with high
                        quality healthcare in a friendly and compassionate
                        environment. Some of the major equipments installed and
                        services/facilities available in the hospital to provide
                        patients with “better than the best” service are :
                      </p>
                      <div className="row mb-4">
                        <div className="col-md-6">
                          <ul className="list-group list-group-flush">
                            {servicesLive
                              .slice(0, Math.ceil(servicesLive.length / 2))
                              .map((item) => (
                                <li
                                  key={item.id}
                                  style={{
                                    border: "1px solid #AF9763",
                                    borderRadius: "5px",
                                    fontSize: "14px",
                                  }}
                                  className="list-group-item bg-transparent mb-2"
                                >
                                  {/* <strong>{`${item.id})`}</strong>{" "} */}
                                  {item.service}
                                </li>
                              ))}
                          </ul>
                        </div>
                        <div className="col-md-6">
                          <ul className="list-group list-group-flush">
                            {servicesLive
                              .slice(Math.ceil(servicesLive.length / 2))
                              .map((item) => (
                                <li
                                  key={item.id}
                                  style={{
                                    border: "1px solid #AF9763",
                                    borderRadius: "5px",
                                    fontSize: "14px",
                                  }}
                                  className="list-group-item bg-transparent mb-2"
                                >
                                  {/* <strong>{`${item.id})`}</strong>{" "} */}
                                  {item.service}
                                </li>
                              ))}
                          </ul>
                        </div>
                      </div>
                      <p className="text-justify">
                        United Hospital has set up a specially designed
                        state-of-art Integrated Hospital Information System to
                        record and monitor all activities and to store patient
                        information in digital format for ease of access and
                        long time storage.
                        <br />
                        <br />A major milestone in 2009 has been the permission
                        from the Ministry of Health to start post graduate
                        studies comprising MD in Cardiology and MS in Cardiac
                        Surgery.
                        <br />
                        <br />
                        Besides, United Hospital got the permission to start
                        Nursing College for giving degree in B.Sc in Nursing in
                        2011.
                      </p>
                    </div>
                    {/* <div className="bg-light p-3">
                      <p className="text-justify text-uppercase py-3">
                        We Are Committed To:
                      </p>
                      <div className="row mb-4">
                        <div className="col-md-6">
                          <div className="d-flex flex-column">
                            <div className="d-flex flex-column">
                              <p className="fw-bold">Quality</p>
                              <ul>
                                <li>
                                  Operating at the highest standards of safe and
                                  ethical practices and demonstrating continuous
                                  improvement
                                </li>
                              </ul>
                            </div>
                            <div className="d-flex flex-column">
                              <p className="fw-bold">Effectiveness</p>
                              <ul>
                                <li>
                                  Selecting the most appropriate services to
                                  produce the desired health outcome
                                </li>
                              </ul>
                            </div>
                            <div className="d-flex flex-column">
                              <p className="fw-bold">Integration</p>
                              <ul>
                                <li>
                                  Providing clear pathways by ensuring
                                  collaboration, consultation, effective
                                  communication with health service providers
                                </li>
                              </ul>
                            </div>
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="d-flex flex-column">
                            <div className="d-flex flex-column">
                              <p className="fw-bold">
                                {" "}
                                Caring for the Community
                              </p>
                              <ul>
                                <li>
                                  Promoting health and providing care based on a
                                  commitment to well being of the patients
                                </li>
                              </ul>
                            </div>
                            <div className="d-flex flex-column">
                              <p className="fw-bold"> Caring for the Staff</p>
                              <ul>
                                <li>
                                  Caring for the health of our staff and
                                  developing a culture of trust, and training
                                  for personal and professional growth
                                </li>
                              </ul>
                            </div>
                            <div className="d-flex flex-column">
                              <p className="fw-bold"> Research & Training</p>
                              <ul>
                                <li>
                                  Providing an environment that promises
                                  personal development, learning and research
                                </li>
                              </ul>
                            </div>
                          </div>
                        </div>
                      </div>
                      <p className="text-justify">
                        United Hospital has set up a specially designed
                        state-of-art Integrated Hospital Information System to
                        record and monitor all activities and to store patient
                        information in digital format for ease of access and
                        long time storage.
                        <br />
                        <br />A major milestone in 2009 has been the permission
                        from the Ministry of Health to start post graduate
                        studies comprising MD in Cardiology and MS in Cardiac
                        Surgery.
                        <br />
                        <br />
                        Besides, United Hospital got the permission to start
                        Nursing College for giving degree in B.Sc in Nursing in
                        2011.
                      </p>
                    </div> */}
                  </div>
                  <div
                    className="col-lg-4 col-md-12 d-none d-md-block pt-2"
                    style={{
                      backgroundColor: "#fff",
                      borderRadius: "5px",
                      // width: "100%",
                      // maxWidth: "370px",
                    }}
                  >
                    <div className="text-profile" id="mobile-part">
                      <div id="sidebar-2" className="row">
                        <div className="col-md-12 sidebar-item ">
                          <a
                            className="category-list-link open-cat-list"
                            href="#"
                          >
                            Select Services
                          </a>
                          <ul
                            className="list-unstyled category-list patients-category-list"
                            id="department-list-sidebar"
                          >
                            {services &&
                              services.map((item) => (
                                <Link
                                  to={`/pages/${item.slug}`}
                                  style={{ textDecoration: "none" }}
                                >
                                  <li>
                                    <a className="">{item.department_name}</a>
                                  </li>
                                </Link>
                              ))}
                          </ul>
                        </div>
                      </div>
                    </div>
                    <div
                      className="bookarea mt-3 d-none d-md-block mb-3"
                      style={{ position: "sticky", zIndex: "3333", top: 100 }}
                    >
                      <iframe
                        width="100%"
                        height="315"
                        src={videoLInk}
                        // src="https://www.youtube.com/embed/qG9oD9qxX6g"
                        title="YouTube video player"
                        frameborder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share; muted"
                        allowfullscreen
                      ></iframe>
                      <h5
                        className="text-center p-2 text-light"
                        style={{
                          backgroundColor: "#f58220",
                          marginTop: "-6px",
                        }}
                      >
                        Call Emergency Line
                        <br />
                        10666
                      </h5>
                      <img
                        src={
                          "https://www.uhlbd.com/resources/images/contact.jpg"
                        }
                        alt=""
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
      <Route component={Footer} />
    </div>
  );
};

export default About;



// WEBPACK FOOTER //
// ./src/component/frontend/About.js